import { createSlice } from '@reduxjs/toolkit'

interface FormDataState {
    value: any
  }

const initialState = {
    value: {
        eligibilityNumber: "",
        firstName: "",
        lastName: "",
        billingAddress: "",
        billingAddress2: "",
        city: "",
        state: "",
        zip: "",
        accountNumber: "",
        accountPIN: "",
        provider: "",
        landline: "",
        primaryAccountHolder: "",
        uuid: "",
        serviceNumberOwnerId: "",
        primaryKeyFromCarrierList: 0,
        customerId: "",
        serviceId: "",
        deviceType: "",
        portSubmitted: false
      },
} as FormDataState

export const formDataSlice = createSlice({
    name: 'formData',
    initialState: initialState,
    reducers: {
        update: (state, action) => {
            // Redux Toolkit allows us to write "mutating" logic in reducers. It
            // doesn't actually mutate the state because it uses the Immer library,
            // which detects changes to a "draft state" and produces a brand new
            // immutable state based off those changes.
            // Also, no return statement is required from these functions.
            state.value = action.payload;
        }
    },
})

export const { update } = formDataSlice.actions;
export default formDataSlice.reducer;